import React from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import About from "@/components/site/About";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import Stats from "@/components/site/Stats";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";

export default function Marketing() {
  return (
    <main className="bg-[#F7F5F0] text-[#0A0A0A]" data-testid="marketing-page">
      <Header />
      <Hero />
      <Services />
      <Process />
      <Stats />
      <Contact />
      <About />
      <Footer />
    </main>
  );
}
